import { Observable } from 'rxjs';
import { ShipmentSpecialFreightTrackingMapStateModel } from './shipment-special-freight-tracking-map.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  ShipmentSpecialFreightTrackingMapLoad,
  ShipmentSpecialFreightTrackingMapInitialState,
} from './shipment-special-freight-tracking-map.actions';
import { ShipmentSpecialFreightTrackingMapState } from './shipment-special-freight-tracking-map.state';
import { ShipmentSpecialFreightMapData } from '../../models/shipment-special-freight-tracking-map.model';
import { SpecialFreightIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightTrackingMapFacade implements LoadDataFacade, SetInitialStateFacade {
  state$: Observable<ShipmentSpecialFreightTrackingMapStateModel> = this.store.select(
    ShipmentSpecialFreightTrackingMapState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentSpecialFreightTrackingMapState.getLoaded);
  mapData$: Observable<ShipmentSpecialFreightMapData> = this.store.select(
    ShipmentSpecialFreightTrackingMapState.getMapData,
  );

  constructor(private store: Store) {}

  loadAll(identifier: SpecialFreightIdView): void {
    this.store.dispatch(new ShipmentSpecialFreightTrackingMapLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentSpecialFreightTrackingMapInitialState());
  }
}
